import React from 'react';
import SectionShell from '../SectionShell';
import Reveal from '../Reveal';
import { useT } from '../../i18n/LanguageContext';

export default function SectionVIP() {
  const { t } = useT();
  return (
    <SectionShell id="vip" className="">
      <div className="mb-16 text-center">
        <Reveal>
          <div className="overline mb-6">{t.vip.overline}</div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.05] text-white mx-auto">
            {t.vip.title}
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <p className="font-ui leading-relaxed vip-sub mx-auto mt-8" data-testid="vip-sub">{t.vip.sub}</p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
        {t.vip.packages.map((pkg, i) => (
          <Reveal key={i} delay={i * 120}>
            <div
              data-testid={`vip-${i + 1}`}
              className="plan-card hairline rounded-sm px-10 pt-12 pb-14 md:px-12 md:pt-14 md:pb-16 bg-white/[0.012] relative overflow-hidden flex flex-col items-center text-center"
            >
              {/* Kicker text — exact PPTX wording, 2 lines */}
              <div className="font-ui text-base md:text-lg text-white/60 leading-snug mb-2">
                {t.vip.cardKicker}
              </div>
              <div className="font-ui text-base md:text-lg text-white/85 leading-snug mb-6">
                {t.vip.cardKicker2}
              </div>

              {/* Bonus number — biggest visual anchor */}
              <div className="font-display text-7xl md:text-8xl text-white tracking-tighter leading-none mb-8">
                {pkg.bonus}
              </div>

              {/* VIP Pack image — bigger */}
              <div className="w-full flex items-center justify-center mb-8">
                <img
                  src={`/source-pptx/image${46 + i}-cut.png`}
                  alt={`${pkg.name} Paket`}
                  loading="lazy"
                  className="block w-full max-w-[460px] h-auto object-contain select-none"
                  style={{ filter: 'drop-shadow(0 22px 44px rgba(0,0,0,0.6))' }}
                  draggable={false}
                />
              </div>

              {/* Price directly below image, tight spacing */}
              <div className="font-display text-6xl md:text-7xl text-white tracking-tighter leading-none">
                {pkg.price}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </SectionShell>
  );
}
